import React, { Component } from "react";
import { ThemeProvider } from "styled-components";

import { aspectRatio as ar } from "../../../../common/parameters";

import { StyledFrame, Container } from "./styles";
import { IProps } from "./interfaces";
import colors from "../../../style/colors";

class Frame extends Component<IProps> {
    state = {
        scale: 0,
        width: 0,
        height: 0,
    };
    timer?: ReturnType<typeof setTimeout>
    componentDidMount() {
        if (this.props.fixed) {
            this.setState({ scale: 0.8, width: 1280, height: 720 * 0.83 });
        } else {
            this.setDimensionsHandler();
            window.addEventListener("resize", this.setDimensions);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.setDimensions);
        clearTimeout(this.timer);
    }
    setDimensions = () => {
        clearTimeout(this.timer);
        setTimeout(() => {
            this.setDimensionsHandler();
        }, 25);
        this.timer = setTimeout(this.setDimensionsHandler, 525);
    };
    setDimensionsHandler = () => {
        const { width, height } = this.props.parent.getBoundingClientRect();
        let parentAR = width / height;
        let frameAR = ar.width / ar.height;
        let scale;
        if (parentAR > frameAR) {
            scale = height / ar.height;
        } else {
            scale = width / ar.width;
        }
        this.setState({ scale, width, height });
    };
    render() {
        const { scale, width, height } = this.state;
        const { transparent, backgroundColor, isFlow, isExperience, contextScale, theme } = this.props;
        return (
            <StyledFrame
                style={{
                    width: width / (contextScale || 1),
                    height: height / (contextScale || 1),
                }}
                transparent={transparent}
                backgroundColor={backgroundColor}
            >
                <ThemeProvider theme={{
                    ...theme,
                    mode: "light",
                    c: {
                        ...theme.c,
                        ...colors,
                        score: theme.c.score,
                        solfa: theme.c.solfa,
                    }
                }}>
                    <div
                        style={{
                            width: ar.width * scale / (contextScale || 1),
                            height: ar.height * scale / (contextScale || 1),
                        }}
                    >
                        <Container
                            isFlowExperience={isExperience && isFlow}
                            style={{
                                width: ar.width,
                                height: ar.height,
                                transform: `scale(${scale / (contextScale || 1)}, ${scale / (contextScale || 1)})`,
                                ...(transparent && {
                                    boxShadow: "none"
                                })
                            }}
                        >
                            {this.props.children}
                        </Container>
                    </div>
                </ThemeProvider>
            </StyledFrame>
        );
    }
}

export default Frame;
